export const VISIBLE_ITEMS_COUNT = 5;

export const MIN_SYMBOLS_TO_SEARCH = 1;
